import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image19.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }

  a {
    &:active, &:visited, &:link {
      color: #5c91f5;
      text-decoration: underline;
    }

    &:hover {
      text-decoration: none;
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const WhatToExpectStep3 = () => (
  <Wrapper>
    <Container>
      <Text1>What To Expect</Text1>
      <Text2>Round 2 | operation discipline is emphasized</Text2>
      <Text3>
        Round 2 presents an additional layer of complexity with lead time becoming
        a significant factor for customers and with competitors' repositioning their
        strategies due to new information learned from round 1 performance.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>

      <Text3>
        As a result of the lead time factor, Ops will have a new decision to consider:<br />
        <b>Should a distribution center be opened? If so, where?</b><br />
        <b className="black-note">Note:</b> Product, on the other hand, will be re-evaluating
        their <a href="https://www.mindtools.com/pages/article/newTMC_90.htm" target="_blank" rel="noreferrer">product market expansion strategies</a> given competitors' positioning.
      </Text3>
    </Container>
  </Wrapper>
);

export default WhatToExpectStep3;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/what-to-expect/step3.js